import { render, staticRenderFns } from "./survey-review.vue?vue&type=template&id=595e8297&scoped=true&"
import script from "./survey-review.vue?vue&type=script&lang=js&"
export * from "./survey-review.vue?vue&type=script&lang=js&"
import style0 from "./survey-review.vue?vue&type=style&index=0&id=595e8297&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e8297",
  null
  
)

component.options.__file = "survey-review.vue"
export default component.exports